import { FC } from 'react';
import arrowLeft from 'shared/assets/arrow_left.svg'
import styles from './ButtonBack.module.scss';
import { Image } from 'shared/ui/image';

type ButtonBackProps = {
  onClick: () => void
}

export const ButtonBack: FC<ButtonBackProps> = ({
  onClick
}) => {
  return (
    <div onClick={onClick} className={styles.buttonBack}>
      <Image 
        src={arrowLeft}
        size='32px'
      />
      <span>Вернуться</span>
    </div>
  )
}